import { Box, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ReusableToggle({
  value,               
  onChange,            
  leftValue = "left",
  rightValue = "right",
  leftIcon,
  rightIcon,
  width = 100,
  height = 44,
}) {
  const theme = useTheme();
  const isLeft = value === leftValue;

  const toggle = () => {
    onChange(isLeft ? rightValue : leftValue);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Box
        onClick={toggle}
        sx={{
          position: "relative",
          width,
          height,
          borderRadius: height / 2,
          backgroundColor: "#eee",
          display: "flex",
          cursor: "pointer",
          userSelect: "none",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "100%",
            borderRadius: height / 2,
            backgroundColor: "#fff",
            left: isLeft ? 0 : "50%",
            boxShadow: 2,
            transition: "left 0.25s ease",
          }}
        />

        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <FontAwesomeIcon
            icon={leftIcon}
            style={{
              color: isLeft ? theme.palette.primary.main : theme.palette.grey[600],
              transition: "color 0.25s",
            }}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <FontAwesomeIcon
            icon={rightIcon}
            style={{
              color: !isLeft ? theme.palette.primary.main : theme.palette.grey[600],
              transition: "color 0.25s",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
